export default __webpack_public_path__ + "static/media/presentation.d6c670a8.pptx";